import { useEffect } from 'react';
import Menu from '@mui/icons-material/Menu';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Stack, AppBar, Toolbar, IconButton } from '@mui/material';
// components
import { useDispatch } from '../../redux/store';
import { getNotifications } from '../../redux/slices/user';
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import CreatePopover from './CreatePopover';

const DRAWER_WIDTH = 260;
const DRAWER_WIDTH_COLLAPSED = 88;
const APPBAR_MOBILE = 56;
const APPBAR_DESKTOP = 52;

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isCollapsed'
})<{ isCollapsed?: boolean }>(({ theme, isCollapsed }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.9),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${(isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH) + 1}px)`
  }
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 3)
  }
}));

type DashboardNavbarProps = {
  onOpenSidebar: VoidFunction;
  isCollapsed?: boolean;
};

export default function DashboardNavbar({ onOpenSidebar, isCollapsed }: DashboardNavbarProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  return (
    <RootStyle isCollapsed={isCollapsed}>
      <ToolbarStyle>
        <IconButton
          onClick={onOpenSidebar}
          sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}
        >
          <Menu />
        </IconButton>

        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={{ xs: 0.5, sm: 1.5 }} sx={{ alignItems: 'center' }}>
          <CreatePopover />
          <NotificationsPopover />
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
